/**
 * Cstretchmodal Component
 * Full-screen modal container styled like Cauthmodal
 */

'use client';

import type { ReactElement } from 'react';
import type { CstretchmodalProps } from './Cstretchmodal.types';
import { CstretchmodalView } from './CstretchmodalView';
import { useCstretchmodalController } from './useCstretchmodalController';

export type { CstretchmodalProps } from './Cstretchmodal.types';

export function Cstretchmodal({
  dataElScope,
  visible,
  children,
  onClose,
  padding = '48px 40px',
  showBackButton = true,
  compactAsMobile = true,
  header,
  footer,
  floatingFooter = false,
  bodyRef,
  className,
  style,
  modalWrapperStyle,
  contentContainerStyle,
  overlayPortalTargetId,
  debugName,
  debugContext,
}: CstretchmodalProps): ReactElement {
  const controller = useCstretchmodalController({
    compactAsMobile,
    contentContainerStyle,
    debugContext,
    debugName,
    modalWrapperStyle,
    onClose,
    overlayPortalTargetId,
    padding,
    showBackButton,
    style,
    visible,
  });

  return (
    <CstretchmodalView
      bodyRef={bodyRef}
      className={className}
      controller={controller}
      dataElScope={dataElScope}
      floatingFooter={floatingFooter}
      footer={footer}
      header={header}
      overlayPortalTargetId={overlayPortalTargetId}
      showBackButton={showBackButton}
      visible={visible}
    >
      {children}
    </CstretchmodalView>
  );
}
